// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import NavigateXHRSelector from '@tcp/core/src/components/features/account/NavigateXHR/container/NavigateXHR.selectors';
import { getBrandTabAnchorToButtonEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getNavigationXHR } from './BrandTabs.actions';
import BrandTabsWrapper from './BrandTabsWrapper';

export const mapDispatchToProps = (dispatch) => {
  return {
    getNavigationXHR: (payload) => {
      dispatch(getNavigationXHR(payload));
    },
  };
};

export const mapStateToProps = (state) => {
  return {
    cookieToken: NavigateXHRSelector.getCookieToken(state),
    brandTabAnchorToButtonEnabled: getBrandTabAnchorToButtonEnabled(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BrandTabsWrapper);
